<template>
  <v-card
    class="pa-5"
  >
    <v-layout>
      <v-flex text-xs-center>
        <div class="display-2 mb-3">
          <strong v-if="totalModule > completion">{{ score >= minimum ? 'Good Job' : 'Not Passed' }}</strong>
          <strong v-else>Congratulations!</strong>
        </div>
        <!--<div class="subheading">{{ score }}/{{ total }}</div>-->
        <div class="title mb-5">
          <!--<span v-if="totalModule > completion" class="secondary--text">You need to complete the {{totalModule - completion}} remaining  modules to Earn 6 CPD Units.</span>-->
          <!--<span v-else class="secondary--text">You have now completed the course and earned 6 CPD Units.</span>-->
          <span class="secondary--text">Congratulations. You have just earned 1 CPD unit for completing this module. Please don't forget to share your feedback on your experience.</span>
          <!--<span v-else class="secondary--text">Kindly review your answers and try again.</span>-->
        </div>

        <!--<div class="mb-3">
          <v-avatar
            :color="pointsColor"
            size="150"
          >
            <span class="white--text display-4"><strong>{{ score >= minimum ? points : 0 }}</strong></span>
          </v-avatar>
        </div>
        <div class="headline mb-3">
          <strong>CPD Points Earned</strong>
        </div>-->

        <!--<div class="mb-3" v-if="completion >= totalModule">-->
         <div class="mb-3" v-if="completion >= totalModule">
          <div>We want to kindly ask you to fill in the following short questionnaire</div>
          <div>We highly value your feedback on Merck</div>
          <div>Please Click <a href="https://docs.google.com/forms/d/e/1FAIpQLScWTZpNcwuANyhPFZT0sifQ_IjGlIPZf3GNwZon-8Ab_tSxOg/viewform" target="_blank">here</a></div>
        </div>

        <div>
          <v-btn
            large
            light
            outline
            class="secondary"
            to="/dashboard"
            v-if="score >= minimum"
          >
            Home
          </v-btn>
          <v-btn
            large
            light
            outline
            class="secondary"
            @click="this.retry"
            v-if="score < minimum"
          >
            Retry
          </v-btn>
          <v-btn
            large
            light
            outline
            class="secondary"
            @click="this.reviewModule"
            v-if="score < minimum"
          >
            Review Module
          </v-btn>
          <v-btn
            large
            flat
            class="accent"
            :to="`/certificate/${certificateCode}`"
            v-if="certificateCode"
          >
            View Certificate
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      pointsColor: this.points > 0 ? 'accent' : 'error'
    }
  },
  props: {
    certificateCode: String,
    score: {
      default: 0
    },
    total: {
      default: 0
    },
    points: {
      default: 2.3
    },
    retry: {
      type: Function
    },
    reviewModule: {
      type: Function
    },
    minimum: Number,
    completion: Number,
    totalModule: Number
  }
}
</script>



// WEBPACK FOOTER //
// src/components/module/assessment/assessmentResult.vue